import {
  GET_PERMISSION_RESPONSE,
  LOGIN_RESPONSE,
  CHANGE_PASSWORD_SETTLED,
} from "./types";
import { getInitialAuthLoginState } from "../../utils/authStorage";

const INITIAL_STATE = {
  login: getInitialAuthLoginState(),
  permission: [],
  changePasswordSettledSeq: 0,
};

const auth = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_RESPONSE:
      return { ...state, login: action.payload };
    case GET_PERMISSION_RESPONSE:
      return {
        ...state,
        permission: action.payload,
      };
    case CHANGE_PASSWORD_SETTLED:
      return {
        ...state,
        changePasswordSettledSeq: (state.changePasswordSettledSeq ?? 0) + 1,
      };
    default:
      return state;
  }
};

export default auth;
